import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { getPaletteUtils } from '@watershed/style/styleUtils';

export default function usePaletteUtils() {
  const theme = useTheme();
  return useMemo(() => getPaletteUtils(theme.palette), [theme]);
}
